import { Injectable } from "@angular/core";
import { IID_FEASABILITY_ASSOCIATION } from "@common/interfaces/interfaceData";
import { ID } from "@common/interfaces/id";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { PersistedStoreConfig } from "@persistence/persisted-store-config";
import { InterfaceDataStore } from "../interfaceDataRegistry";

export interface IIDFeasabilityAssociationState extends EntityState<IID_FEASABILITY_ASSOCIATION, ID> {}

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_FEASABILITY_ASSOCIATION , realtimeEntity: 'IID_FeasabilityAssociation'})
@InterfaceDataStore(InterfaceName.IID_FEASABILITY_ASSOCIATION)
export class IIDFeasabilityAssociationStore extends EntityStore<IIDFeasabilityAssociationState> {
  constructor() {
    super([]);
  }
}
